import { Box, Flex, Show, Button, Icon, Drawer, DrawerContent } from '@chakra-ui/react';
import { MainLogoLarge, MainLogoSmall } from '../../../assets/icons';
import { useToggle } from '../../../hooks';
import { IoCloseSharp } from 'react-icons/io5';
import { HiOutlineMenuAlt3 } from 'react-icons/hi';
import { NavSideBarContent } from './NavSideBarContent';
import { RefObject, useRef } from 'react';

export const NavSideBar = () => {
  const { show, isShow, hide } = useToggle();
  const drawerWrapperRef: RefObject<HTMLDivElement> = useRef(null);

  return (
    <>
      {/* Desktop */}
      <Show above='lg'>
        <Flex position='fixed' maxW='330px' w='100%' background='brand.blueExtraDark' h='100%' flexDir='column'>
          <Box h='52px' sx={{ svg: { height: '100%', width: '100%' } }} pt={30} boxSizing='initial'>
            <MainLogoLarge />
          </Box>
          <Box flexGrow={1}>
            <NavSideBarContent />
          </Box>
        </Flex>
      </Show>

      {/* Mobile */}
      <Show below='lg'>
        <Box position='fixed' w='100%' zIndex={100}>
          <Flex
            background='brand.blueExtraDark'
            sx={{ svg: { height: '100%', width: 'initial' } }}
            justifyContent='space-between'
            py={4}
            px={5}
            alignItems='center'
            borderBottomRightRadius={25}
          >
            <Box h='30px'>
              <MainLogoSmall />
            </Box>

            <Button onClick={() => (isShow ? hide() : show())} variant='link' p={2} mr={-2} minWidth='initial' h='40px'>
              <Icon as={isShow ? IoCloseSharp : HiOutlineMenuAlt3} color='brand.cyan' />
            </Button>
          </Flex>
        </Box>

        <Box ref={drawerWrapperRef} sx={{ '--chakra-zIndices-modal': '2' }}>
          <Drawer
            onClose={hide}
            isOpen={isShow}
            size='full'
            placement='top'
            portalProps={{ containerRef: drawerWrapperRef }}
          >
            <DrawerContent background='brand.blueExtraDark' pt='72px' overflowY='auto' h='100%'>
              <NavSideBarContent onCloseSideBar={hide} />
            </DrawerContent>
          </Drawer>
        </Box>
      </Show>
    </>
  );
};
